module.exports = __webpack_public_path__ + "static/media/UpperColon.5884391d.svg";